import { getPf } from "../utils/conf";

const oauthConfig: Record<
  string,
  {
    authUrl: string;
    clientId: string;
    redirectUri: string;
    scope?: string;
    responseType?: string;
    responseMode?: string; // Optional property
    state?: string;
    access_type?: string;
  }
> = {
  google: {
    authUrl: "https://accounts.google.com/o/oauth2/auth",
    // clientId:
    //   "263139161286-gmlj83ajicrdrjrctjith3ahjivfokkq.apps.googleusercontent.com",
    clientId:
      "715699782342-vbmklrsq129rd293a0j7emdhas9d4lgb.apps.googleusercontent.com",
    redirectUri:
      ((getPf() === "TAMICE"
        ? process.env.REACT_APP_REDIRECT_APP_API_URL
        : process.env.REACT_APP_REDIRECT_APP_API_URL_TRAVITY) as string) +
      "/oauth/google",
    responseType: "code",
    scope: "email",
    // scope: "email profile openid",
    access_type: "offline",
  },
  kakao: {
    authUrl: "https://kauth.kakao.com/oauth/authorize",
    // clientId: '311197c0a3d1e42021e82dd8c7ed8deb',
    // redirectUri: 'http://98.83.31.160:3000/oauth',
    clientId: process.env.REACT_APP_KAKAO_JS_KEY as string,
    redirectUri:
      ((getPf() === "TAMICE"
        ? process.env.REACT_APP_REDIRECT_APP_API_URL
        : process.env.REACT_APP_REDIRECT_APP_API_URL_TRAVITY) as string) +
      "/oauth/kakao",
    responseType: "code",
  },
  apple: {
    authUrl: "https://appleid.apple.com/auth/authorize",
    // clientId: "com.tamice",
    clientId: "com.tamice.web.login",
    redirectUri:
      ((getPf() === "TAMICE"
        ? process.env.REACT_APP_REDIRECT_APP_API_URL
        : process.env.REACT_APP_REDIRECT_APP_API_URL_TRAVITY) as string) +
      "/oauth/apple",
    // scope: "name email", // must use form_post response mode to receive email or name
    scope: "",
    responseType: "code",
    // responseMode: "form_post", // Apple-specific
    state: "YOUR_STATE",
  },
  naver: {
    authUrl: "https://nid.naver.com/oauth2.0/authorize",
    clientId: process.env.REACT_APP_NAVER_CLIENT_ID as string,
    redirectUri:
      ((getPf() === "TAMICE"
        ? process.env.REACT_APP_REDIRECT_APP_API_URL
        : process.env.REACT_APP_REDIRECT_APP_API_URL_TRAVITY) as string) +
      "/oauth/naver",
    scope: "name email",
    responseType: "code",
    state: "random_state_value",
  },
};

export default oauthConfig;
